import { Component, h } from 'preact'
import { TFunctionDetailedResult } from 'i18next'

import { SelectOption } from 'common-modules/select-preact/select-preact'
import AmountInputFieldset from 'common-modules/amount-input'
import CalculatorSelect from 'common-modules/calculator-select'

interface CalculatorInputProps {
  label: TFunctionDetailedResult
  amount: string
  handleAmountChange: (value: string) => void
  isSpinner: boolean
  classNames: string
  wrapperClassNames: string
  handleCurrencyChange: (option: SelectOption) => void
  value: string
  currencies: string[]
  wrapperClassNamesSelect?: string
  errorMessageCurrency?: TFunctionDetailedResult | null
  wrapperBoxClassNames?: string
}

export default class CalculatorInput extends Component<CalculatorInputProps> {
  public render() {
    return (
      <div className="hero-form__section hero-form__section-currency">
        <div className={`hero-form__input-block ${this.props.wrapperBoxClassNames}`}>
          <div className="hero-form__input-block-label">
            <div className="hero-form__input-block-label-text">{this.props.label}</div>
          </div>
          <div className="hero-form__combined-inputs">
            <AmountInputFieldset
              amount={this.props.amount}
              handleAmount={this.props.handleAmountChange}
              isSpinner={this.props.isSpinner}
              wrapperClassNames={this.props.wrapperClassNames}
              classNames={this.props.classNames}
            />
            <div className={this.props.wrapperClassNamesSelect}>
              <CalculatorSelect
                onChange={this.props.handleCurrencyChange}
                currencies={this.props.currencies}
                value={this.props.value}
              />
            </div>
          </div>
          {this.props.errorMessageCurrency && (
            <p className="hero-form__error-text">{this.props.errorMessageCurrency}</p>
          )}
        </div>
      </div>
    )
  }
}
